import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.promise";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es7.promise.finally";
import "core-js/modules/es6.number.constructor";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState, mapGetters } from 'vuex';
import ApiService from '@/services/apiService';
import { randomPassword, isNullOrEmpty } from '@/utils/vuex';
import pullAt from 'lodash/pullAt';
import cloneDeep from 'lodash/cloneDeep';
import set from 'lodash/set';
import get from 'lodash/get';
export default {
  name: 'CoreTenantDialogCreateUser',
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    tenantId: {
      type: Number,
      default: null
    }
  },
  data: function data() {
    return {
      tenantDetails: null,
      userKeyValue: [],
      loading: false,
      valid: false,
      originalUser: null,
      createdUser: {
        firstName: null,
        lastName: null,
        email: null,
        password: '',
        active: true,
        properties: {
          values: [{
            key: '',
            value: ''
          }]
        },
        scope: null,
        access: []
      },
      defaultPasswordPolicy: {},
      editFormValidity: false
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'color', 'permissions'])), mapState('authentication', ['user'])), mapGetters({
    sessionUserId: 'authentication/userId',
    sessionPrimaryTenantIds: 'authentication/primaryTenantIds',
    sessionAccess: 'authentication/access'
  })), {}, {
    mode: function mode() {
      return this.$route.params.id ? 'update' : 'create';
    },
    requiredRule: function requiredRule() {
      var _this = this;

      return [function (v) {
        return !!v || _this.$i18n_t('Common.fieldRequired');
      }];
    },
    passwordRules: function passwordRules() {
      var _this2 = this;

      return [function (v) {
        return !!v || _this2.$i18n_t('accMgmt.user.passwordErrors.USER_PASSWORD_REQUIRED');
      }, function (v) {
        return v.length >= _this2.defaultPasswordPolicy.length || _this2.$i18n_tc('accMgmt.user.passwordErrors.USER_PASSWORD_MINLENGTH', _this2.defaultPasswordPolicy.length, {
          n: _this2.defaultPasswordPolicy.length
        });
      }];
    },
    emailRules: function emailRules() {
      var _this3 = this;

      return [function (v) {
        return !!v || _this3.$i18n_t('Common.fieldRequired');
      }, function (v) {
        return /.+@.+\..+/.test(v) || _this3.$i18n_t('Common.emailValid');
      }];
    }
  }),
  mounted: function mounted() {
    var _this4 = this;

    this.$store.state.app.loading = false;
    return this.fetchTenantData().then(function () {
      if (_this4.tenantId) {
        return ApiService.getUser(_this4, _this4.$store.state.authentication.user.id).then(function (data) {
          _this4.setUserDetails(data);
        }).finally(function () {
          _this4.$store.state.app.loading = false;
        });
      } else {
        _this4.setUserDetails({
          active: true
        });
      }
    });
  },
  methods: {
    dataCyFromPropertyKey: function dataCyFromPropertyKey(key, name) {
      var propName = key.toLowerCase().replace(/[^a-z0-9_]/g, '_');
      return propName ? "".concat(name, "_").concat(propName) : undefined;
    },
    requiredRuleKeyValue: function requiredRuleKeyValue(kv) {
      var _this5 = this;

      return [function (v) {
        return isNullOrEmpty(kv.key) && isNullOrEmpty(kv.value) || !!v || _this5.$i18n_t('Common.fieldRequired');
      }];
    },
    didSelectScope: function didSelectScope(scope) {
      this.createdUser.scope = scope;
      this.fetchDefaultRoles(scope.id);
    },
    fetchDefaultRoles: function fetchDefaultRoles(scopeId) {
      var _this6 = this;

      ApiService.fetchDefaultRoles(scopeId).then(function (roles) {
        _this6.createdUser.access = [{
          tenantId: get(roles, '[0].tenantId') || _this6.tenantId,
          scopeId: scopeId,
          Scope: {
            id: scopeId
          },
          roles: roles,
          primary: true
        }];
        _this6.createdUser = cloneDeep(_this6.createdUser);
      }).catch(function () {
        _this6.$snack(_this6.$i18n_t('accMgmt.user.createFailedSnack'), 'error');
      });
    },
    fetchTenantData: function fetchTenantData() {
      var _this7 = this;

      return Promise.all([ApiService.tenantGetPasswordPolicy(), // NOTE: using `no-descendents` to not get any child-data; this will ALSO _NOT_ load any scope-descendents
      ApiService.tenantGetById(this.tenantId, ['no-descendents'])]).then(function (data) {
        _this7.defaultPasswordPolicy = data[0];
        var tenant = data[1];
        _this7.tenantDetails = tenant;
        return tenant;
      }).catch(function (error) {
        if (error.response && _this7.$i18n_t("Error.".concat(error.response.data.message))) {
          _this7.$snack(_this7.$i18n_t("Error.".concat(error.response.data.message)), 'error');
        } else {
          _this7.$snack('Failed to fetch tenant', 'error');
        }

        _this7.$router.push({
          path: "/account-mgmt/".concat(_this7.tenantId, "?userlist")
        });
      });
    },
    validate: function validate() {
      this.valid = this.$refs && this.$refs.form ? this.$refs.form.validate() : false;

      if (this.valid) {
        this.snackbar = true;
      }
    },
    handleSubmit: function handleSubmit() {
      this.validate();

      if (this.valid) {
        this.saveUser(this.createdUser, this.mode);
      }
    },
    saveUser: function saveUser(userInfo) {
      this.loading = true;
      userInfo.properties.values = get(this, 'userKeyValue', []).filter(function (kv) {
        return kv.key !== '' && kv.value !== '';
      });
      this.$emit('create-user', userInfo);
    },
    addKeyValuePair: function addKeyValuePair() {
      this.userKeyValue = cloneDeep(this.userKeyValue.concat([{
        key: '',
        value: ''
      }]));
    },
    removeKeyValuePair: function removeKeyValuePair(index) {
      pullAt(this.userKeyValue, [index]);

      if (this.userKeyValue.length === 0) {
        this.addKeyValuePair();
      } // trigger a UI refresh


      this.userKeyValue = cloneDeep(this.userKeyValue);
    },
    setUserDetails: function setUserDetails() {
      this.createdUser.password = randomPassword();

      if (!get(this.createdUser, 'access')) {
        set(this.createdUser, 'access', []);
      }

      var userDefaultProperties = get(this.tenantDetails, 'data.userDefaultProperties', []);
      var defaultProperties = userDefaultProperties.map(function (key) {
        return {
          key: key,
          value: ''
        };
      });
      this.createdUser.properties.values = defaultProperties;
      this.userKeyValue = defaultProperties.length > 0 ? defaultProperties : [{
        key: '',
        value: ''
      }];
      this.validate();
    },
    updatedUserAccess: function updatedUserAccess(access) {
      this.createdUser.access = access;

      if ((access || []).length === 0) {
        delete this.createdUser.scope;
      }
    },
    close: function close() {
      this.$emit('closeUserDialog');
    }
  }
};